import { Controller } from "@hotwired/stimulus"

// Prevents double form submission and shows loading indicator
export default class extends Controller {
  static targets = ["submit", "spinner", "text"]
  static values = {
    loadingText: { type: String, default: "Enviando..." }
  }

  connect() {
    this.isSubmitting = false
  }

  submit(event) {
    // Prevent double submission
    if (this.isSubmitting) {
      event.preventDefault()
      return
    }

    this.isSubmitting = true

    // Update button state
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = true
      this.submitTarget.classList.add("opacity-75", "cursor-not-allowed")
    }

    // Show spinner, hide text
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.remove("hidden")
    }

    if (this.hasTextTarget) {
      this.textTarget.textContent = this.loadingTextValue
    }
  }

  // Reset form state (useful if form submission fails)
  reset() {
    this.isSubmitting = false

    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = false
      this.submitTarget.classList.remove("opacity-75", "cursor-not-allowed")
    }

    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.add("hidden")
    }
  }
}
